import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { WebhookListData } from 'app/webhooks/webhook-list/webhook-list.data';
import { WebhookListItem, WebhookSubjectTypeDropdown } from 'app/webhooks/model/webhooks.model';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IState } from 'app/shared/models/state';
import {
  ChangeWebhookActivityAction,
  DeleteWebhookAction,
  FilterWebhookListAction
} from 'app/webhooks/webhooks.actions';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '../../shared/confirm/confirm.component';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'cc-webhook-list',
  templateUrl: './webhook-list.component.html',
  styleUrls: ['./webhook-list.component.scss']
})
export class WebhookListComponent implements OnInit {
  public displayedColumns = ['webhookName', 'active', 'actions'];
  public matDataSource: MatTableDataSource<WebhookListItem>;

  constructor(
    public dataSource: WebhookListData,
    private router: Router,
    private store: Store<IState>,
    private dialog: MatDialog
  ) {
    this.dataSource.init();
  }

  ngOnInit() {
    this.dataSource.connect().subscribe(data => {
      this.matDataSource = new MatTableDataSource(data);
    });
  }

  changeActive(element: WebhookListItem) {
    this.store.dispatch(new ChangeWebhookActivityAction({ id: element.id, isActive: !element.active }));
  }

  edit(element: WebhookListItem) {
    this.router.navigateByUrl('/webhooks/edit/' + element.id);
  }

  delete(element: WebhookListItem) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: {
        title: 'WEBHOOKS.DELETE.TITLE',
        body: 'WEBHOOKS.DELETE.DESCRIPTION',
        type: 'strong'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(new DeleteWebhookAction(element.id));
      }
    });
  }

  filterList(subjectType: WebhookSubjectTypeDropdown) {
    this.store.dispatch(new FilterWebhookListAction(subjectType));
  }

  filterByTypeAvailable() {
    // currently, in Channels, we've got only one type of webhooks (per project = global)
    return false;
  }
}
